export default __webpack_public_path__ + "static/media/alert@2x.a5052115.svg";